import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./index.css";
import { withTranslation } from "../../translation";
import useCountdown from "../../hooks/useCountdown";
import { formatBannerCountdownTime } from "../CategoryHeaderCopy/formatCountdownTime";
import { formatDateForLoyalty } from "../CategoryHeaderCopy/formatDateForLoyalty";
import { ACCESS_LEVEL_VIEW } from "../../../constants";
import getTapingKey from "../CategoryHeaderCopy/getTapingKey";

const getBannerText = ({
  customerAccess,
  showCountdown,
  remainingSeconds,
  endDate,
  formatTranslation,
}) => {
  const tapingKey = getTapingKey(customerAccess, showCountdown);

  if (!tapingKey) return null;

  return showCountdown
    ? formatTranslation(tapingKey, {
        time: formatBannerCountdownTime(remainingSeconds),
      })
    : formatTranslation(tapingKey, { date: formatDateForLoyalty(endDate) });
};

const EarlyAccessBanner = ({ endDate, customerAccess, formatTranslation }) => {
  const { remainingSeconds, showCountdown } = useCountdown(endDate);

  const bannerText = getBannerText({
    customerAccess,
    showCountdown,
    remainingSeconds,
    endDate,
    formatTranslation,
  });

  if (!bannerText) {
    return null;
  }

  const isComingSoon = customerAccess === ACCESS_LEVEL_VIEW;

  return (
    <div
      className={classNames(styles.banner, {
        [styles.comingSoon]: isComingSoon,
        [styles.earlyAccess]: !isComingSoon,
      })}
      aria-label={bannerText}
    >
      <span className={styles.bannerText}>{bannerText}</span>
    </div>
  );
};

EarlyAccessBanner.propTypes = {
  endDate: PropTypes.string.isRequired,
  customerAccess: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
};

export default withTranslation(EarlyAccessBanner);
